import register from "../utils/errorHandler/register";
export default function getMessageFromErrorCode(errorCode, err) {
    return register.getMessage(errorCode, err);
}
